import {
  Area,
  AreaChart,
  ResponsiveContainer,
  YAxis,
} from 'recharts';
import { PRIMARY_HEX } from '@/lib/colors';

export type SparklineProps = {
  data: number[];
  height?: number;
  ariaLabel?: string;
};

export function Sparkline({ data, height = 36, ariaLabel }: SparklineProps) {
  const chartData = data.map((v, i) => ({ i, v }));
  if (chartData.length === 0) {
    return <div style={{ height }} className="w-full" aria-hidden />;
  }
  return (
    <div style={{ height }} className="w-full" role="img" aria-label={ariaLabel}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData} margin={{ top: 2, right: 0, left: 0, bottom: 0 }}>
          <YAxis domain={['dataMin', 'dataMax']} hide width={0} />
          <Area
            type="monotone"
            dataKey="v"
            stroke={PRIMARY_HEX}
            strokeWidth={1.5}
            fill={PRIMARY_HEX}
            fillOpacity={0.15}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
